import { all, any, compose, filter, includes, keys, not } from 'ramda';
import { isNilOrEmpty, isNilOrEmptyString } from 'ramda-extension';

import { toIsoDateFormat } from 'utils';

import { allowedSearchCombination, PARAMS_WITH_ADDED_ASTERISK } from './constants';
import { FIELDS } from './form';

export const requestFactory = (formData) => {
	const body = {};

	const filteredFormData = filter((val) => !isNilOrEmptyString(val))(formData);
	const keys = Object.keys(filteredFormData);

	if (!isNilOrEmpty(keys)) {
		keys.forEach((key) => {
			if (PARAMS_WITH_ADDED_ASTERISK.includes(key)) {
				body[key] = `${formData[key]}*`;
			} else if (key === FIELDS.personIn) {
				body.birthNumber = formData[key];
			} else if (key === FIELDS.birthDate) {
				body.birthDate = toIsoDateFormat(formData.birthDate);
			} else {
				body[key] = formData[key];
			}
		});
	}

	return body;
};

export const checkAllowedSearchCombinations = compose(
	// checks if keys are allowed combination
	(formKeys) => any(all((key) => includes(key, formKeys)))(allowedSearchCombination),
	// returns array of form field keys that are not empty
	compose(keys, filter(compose(not, isNilOrEmptyString))),
);
